import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import ElectricRickshawIcon from "@mui/icons-material/ElectricRickshaw";
import GroupIcon from "@mui/icons-material/Group";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import React from "react";

import LoopIcon from "@mui/icons-material/Loop";
import PaymentIcon from "@mui/icons-material/Payment";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import HouseSidingIcon from '@mui/icons-material/HouseSiding';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import DateRangeIcon from '@mui/icons-material/DateRange';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SettingsIcon from '@mui/icons-material/Settings';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';


export const promiseKannadaList = [
  {
    id: 1,
    icon: <ElectricRickshawIcon />,
    question: "ವಿದ್ಯುತ್ ಹಾರುಹಿಡಿಯಲು ವಿಶಾಲ ವಾಹನಗಳ ವ್ಯಾಪ್ತಿ",
    answer:
      "ನಾವು ಪ್ರಮುಖ ನಿರ್ಮಾಣಕರುಗಳ ವಿದ್ಯುತ್ ಹಾರುಹಿಡಿಯಲು ಅನೇಕ ಬ್ರಾಂಡ್‌ಗಳ ವಿದ್ಯುತ್ ವಾಹನಗಳ ವಿಸ್ತಾರವನ್ನು ಒದಾರಿಸುತ್ತೇವೆ, ಅವುಗಳಲ್ಲಿ Mahindra, Piaggio, E-trio, Euler, Greaves, Altigreen ಮತ್ತು OSM ಇವೆ.",
  },

  {
    id: 2,
    icon: <GroupIcon />,
    question: "ವಿದ್ಯುತ್ ವಾಣಿಜ್ಯ ವಿಶೇಷಜ್ಞರ ತಂಡ",
    answer:
      "ನಮ್ಮ ಆವಶ್ಯಕತೆಗಳಿಗೆ ಸರಿಯಾದ ವಿದ್ಯುತ್ ವಾಣಿಜ್ಯ ವಾಹನವನ್ನು ಆಯ್ಕೆಮಾಡಲು ವ್ಯಾಪಾರಗಳು ಹಾಗೂ ವ್ಯಕ್ತಿಗಳಿಗೆ ಸಹಾಯ ಮಾಡಬಹುದಾದ ವಿಶೇಷಜ್ಞರ ತಂಡವನ್ನು ನಾವು ಹೊಂದಿದ್ದೇವೆ.",
  },

  {
    id: 3,
    icon: <WorkspacePremiumRoundedIcon />,
    question:
      "ಶ್ರೇಷ್ಠ ವಾಣಿಜ್ಯ ವಿದ್ಯುತ್ ವಾಹನಗಳ ಸಾಲಕ್ಕೆ ವಾಣಿಜ್ಯವನ್ನು ಸುಲಭಗೊಳಿಸಲು ವ್ಯವಸ್ಥೆ",
    answer:
      "ವಿದ್ಯುತ್ ಸಾಲಗಳನ್ನು ಖರೀದಿಸಲು ನಾವು ಸುಲಭಗೊಳಿಸಲು ವಾಣಿಜ್ಯವನ್ನು ಪಡೆಯುತ್ತೇವೆ.",
  },

  {
    id: 4,
    icon: <BuildCircleIcon />,
    question: "ರಕ್ಷಣೆ ಮತ್ತು ಮರವಣಿಕಾ ಸೇವೆ",
    answer:
      "ವಿದ್ಯುತ್ ಹೆವಿ ವಾಹನಗಳನ್ನು ಸಾಗಳವಾಗಿ ಹಾಕಿಕೊಳ್ಳುವಂತೆ ಮಾಡಲು ನಾವು ರಕ್ಷಣೆ ಮತ್ತು ಮರವಣಿಕಾ ಸೇವೆಗಳನ್ನು ಒದಾರಿಸುತ್ತೇವೆ.",
  },
  {
    id: 5,
    icon: <ManageAccountsIcon />,

    question: "ಉಚಿತ ಹೈದರೇ ಟೆಸ್ಟ್ ಡ್ರೈವ್ಸ್",
    answer:
      "ನೀವು ಆಯ್ಕೆಗೆ ವಾಹನದ ಮೇಲೆ ತೀರ್ಗಿತ ನಿರ್ಧಾರಣೆ ಮಾಡಬೇಕೆಂದು ಇದ್ದರೆ, ನಾವು ನಿಮ್ಮ ಮನೆಗೆ ಉಚಿತ ಹೈದರೇ ಟೆಸ್ಟ್ ಡ್ರೈವ್ಸ್ ಒದಾರಿಸುತ್ತೇವೆ.",
  },

  {
    id: 6,
    icon: <PaymentIcon />,
    question: "ಕಡಿಮೆ ಡೌನ್ ಪೇಮೆಂಟ್",
    answer:
      "ಸುಲಭ ಮತ್ತು ವಿವಿಧ ಡೌನ್ ಪೇಮೆಂಟ್ ಆಯ್ಕೆಗಳನ್ನು ಹೊಂದಿ ಅಲ್ಲಿಗೆ ವಾಹನ ವಹಿಸಲು ಸುಲಭವಾಗಿ ಪಡೆಯಿರಿ.",
  },

  {
    id: 7,
    icon: <LoopIcon />,
    question: "ಖಚಿತ ಮರವಣಿಕಾ",
    answer:
      "ಟರ್ನೊ ಖಚಿತ ಮಾಲಿಕತ್ವದ ಹೆಚ್ಚಿನ ಮೌಲ್ಯ ಅಥವ ಇ.ವಿ ಆಟೋಗೆ ಉಪರಿ 40% ಅಥವಾ ₹ 150,000 ವರೆಗೆ ಮರವಣಿಕಾ ಮೌಲ್ಯದ ಹೆಚ್ಚಿನ ಲಾಭವನ್ನು ಅನುಭವಿಸಿರಿ.",
  },
];

export const promiseIceEvList = [
  {
    id: 1,
    icon: <ElectricRickshawIcon />,
    question: "All Top EV Brands in One Place",
    answer:
      "Turno offers a comprehensive platform where you can explore goods electric vehicles from all leading brands in one place. Whether you prefer to book your load electric auto online or visit the Turno showroom, our platform provides a convenient and hassle-free experience. Our team of EV experts is always on hand at Turno to assist you in finding the perfect vehicle for your business needs.",
  },

  {
    id: 2,
    icon: <GroupIcon />,
    question: "Financing Options",
    answer:
      "Turno makes your EV purchase journey seamless by providing assured financing for all three-wheeler load EVs. You will get the best EV loan at Turno with a low-interest rate and easy documentation. Experience the fastest EV loan processing with instant eligibility checks and 48-hour loan disbursals.",
  },

  {
    id: 3,
    icon: <WorkspacePremiumRoundedIcon />,
    question: "Maintenance and Repair Service:",
    answer:
      "We don’t limit our services only to selling mini electric trucks, we also provide post-sale services which include maintenance and repair services. We help you book your scheduled services and provide quick fixes for your vehicle whenever required. It is our assurance that your business will never face any downtime",
  },

  {
    id: 4,
    icon: <PaymentIcon />,
    question: "Lowest Down Payment",
    answer:
      "We make your electric tempo buying easier than ever before with the lowest downpayment facility. Bring home your electric load vehicle at a downpayment of just ₹49,999.",
  },
  {
    id: 5,
    icon: <PublishedWithChangesIcon />,
    question: "Vehicle Exchange",
    answer:
      "Take advantage of Turno's vehicle exchange program to move to an EV auto. We provide the best rates for exchanging any old diesel or CNG vehicle. It just takes 48 hours to exchange any vehicle for an EV at Turno.",
  },

  {
    id: 6,
    icon: <LoopIcon />,

    question: "Assured Resale",
    answer:
      " Turno brings you the unique feature of assured EV resale. You can sell your electric loader back to Turno after 3 years and get an assured resale value of up to 40% or ₹1,50,000 for all goods electric vehicles.",
  },
];
export const passengerVehiclePromiseList = [
  {
    id: 1,
    icon: <SupportAgentIcon />,
    question: "Assistance at Every Step",
    answer:
      "EV experts at Turno help you at every step of your EV owning journey starting from finding the right vehicle to documentation, financing, and post-sales support such as scheduling regular services and more.",
  },
  {
    id: 2,
    icon: <HouseSidingIcon />,
    question: "Free Doorstep Test Drives",
    answer:
      "We offer test drives at the location of your choice for your convenience.",
  },

  {
    id: 3,
    icon: <DateRangeIcon />,
    question: "Lowest Downpayment",
    answer:
      "The lowest downpayment to make the purchase of passenger EVs affordable for you.",
  },

  {
    id: 4,
    icon: <AccountBalanceWalletIcon />,
    question: "Financing Options",
    answer:
      "Get guaranteed financing options to make owning an electric vehicle even more convenient.",
  },
  {
    id: 5,
    icon: <SettingsIcon />,
    question: "Maintenance & Repair Services",
    answer:
      "Post-sale services, such as maintenance and repair, are offered to keep your electric vehicle running smoothly.",
  },

  {
    id: 6,
    icon: <CompareArrowsIcon />,
    question: "Vehicle Exchange",
    answer:
      "Turno's old vehicle exchange program for an easy switch from CNG/diesel to an electric vehicle.",
  },

  {
    id: 7,
    icon: <WorkspacePremiumRoundedIcon />,
    question: "Assured Resale",
    answer:
      "We provide resale value of up to 40% or ₹150,000 for the passenger EV after 3 years.",
  },
];

export const promiseData3wEvEmi11kPassenger = [
  {
    id: 1,
    icon: <SupportAgentIcon />,
    question: "ಪ್ರತಿ ಹಂತದಲ್ಲೂ ಸಹಾಯ:",
    answer:
      "ಸರಿಯಾದ ವಾಹನವನ್ನು ಕಂಡುಹಿಡಿಯುವುದರಿಂದ ಹಿಡಿದು ಡಾಕ್ಯುಮೆಂಟೇಶನ್, ಲೋನ್ ಮತ್ತು ಕ್ರಮವಾಗಿ ಸರ್ವೀಸ್ ಮಾಡಿಸಲು ಶೆಡ್ಯೂಲ್ ಮಾಡುತ್ತಾ ಮಾರಾಟದ ನಂತರದ ಬೆಂಬಲವನ್ನು ನೀಡುತ್ತೇವೆ. ನಿಮ್ಮ EV- ಪ್ರಯಾಣದ ಪ್ರತಿಯೊಂದು ಹಂತದಲ್ಲೂ ಟರ್ನೊದಲ್ಲಿನ EV ಎಕ್ಸ್ ಪರ್ಟ್ ನಿಮಗೆ ಸಹಾಯ ಮಾಡುತ್ತಾರೆ.",
  },
  {
    id: 2,
    icon: <HouseSidingIcon />,
    question: "ಉಚಿತ ಡೋರ್ ಸ್ಟೆಪ್ ಟೆಸ್ಟ್ ಡ್ರೈವ್",
    answer:
      "ನಿಮ್ಮ ಅನುಕೂಲಕ್ಕಾಗಿ ನಿಮ್ಮ ಆಯ್ಕೆಯ ಸ್ಥಳದಲ್ಲಿ ನಾವು ಟೆಸ್ಟ್ ಡ್ರೈವ್ ನೀಡುತ್ತೇವೆ.",
  },
  {
    id: 3,
    icon: <PaymentIcon />,
    question: "ಕಡಿಮೆ ಡೌನ್ ಪೇಮೆಂಟ್",
    answer:
      "ಪ್ಯಾಸೆಂಜರ್ EVಗಳ ಖರೀದಿಯನ್ನು ನಿಮಗೆ ಕೈಗೆಟುಕುವಂತೆ ಮಾಡಲು ಅತ್ಯಂತ ಕಡಿಮೆ ಡೌನ್ ಪೇಮೆಂಟ್.",
  },
  {
    id: 4,
    icon: <GroupIcon />,
    question: "ಲೋನ್ ಆಯ್ಕೆಗಳು:",
    answer:
      "ಎಲೆಕ್ಟ್ರಿಕ್ ವಾಹನವನ್ನು ಹೊಂದುವುದನ್ನು ಇನ್ನಷ್ಟು ಅನುಕೂಲಕರವಾಗಿಸಲು ಖಾತರಿಪಡಿಸಿದ ಹಣಕಾಸು ಆಯ್ಕೆಗಳನ್ನು ಪಡೆಯಿರಿ.",
  },
  {
    id: 5,
    icon: <WorkspacePremiumRoundedIcon />,
    question: "ನಿರ್ವಹಣೆ ಮತ್ತು ದುರಸ್ತಿ ಸೇವೆಗಳು:",
    answer:
      "ನಿಮ್ಮ ಎಲೆಕ್ಟ್ರಿಕ್ ವಾಹನವನ್ನು ಸುಗಮವಾಗಿ ಓಡಿಸಲು ನಿರ್ವಹಣೆ ಮತ್ತು ದುರಸ್ತಿಯಂತಹ ಮಾರಾಟದ ನಂತರದ ಸೇವೆಗಳನ್ನು ನೀಡಲಾಗುತ್ತದೆ.",
  },
  {
    id: 6,
    icon: <PublishedWithChangesIcon />,
    question: "ವಾಹನ ವಿನಿಮಯ",
    answer:
      "ಸಿಎನ್ ಜಿ / ಡೀಸೆಲ್ ನಿಂದ ಎಲೆಕ್ಟ್ರಿಕ್ ವಾಹನಕ್ಕೆ ಸುಲಭವಾಗಿ ಬದಲಾಯಿಸಲು ಟರ್ನೊದ ಹಳೆಯ ವಾಹನ ವಿನಿಮಯ ಕಾರ್ಯಕ್ರಮ.",
  },
  {
    id: 7,
    icon: <LoopIcon />,

    question: "ಭರವಸೆಯ ಮರುಮಾರಾಟ",
    answer:
      "ಟರ್ನೊ ಮಾತ್ರ 3 ವರ್ಷಗಳ ನಂತರ ಬಜಾಜ್ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋ ಪ್ಯಾಸೆಂಜರ್ EVಗೆ 40% ಅಥವಾ ₹ 150,000 ವರೆಗೆ ಮರುಮಾರಾಟ ಮೌಲ್ಯವನ್ನು ಒದಗಿಸುತ್ತದೆ.",
  },
];

export const promiseData2wTo3wHindi = [
  {
    id: 1,
    icon: <ElectricRickshawIcon />,
    question: "सभी टॉप EV ब्रांड एक ही जगह में",
    answer:
      "Turno एक ऐसी प्लेटफ़ॉर्म है जहां आप एक ही जगह से सभी प्रमुख ब्रांड के इलेक्ट्रिक गाड़िया खरीद सकते हैं। चाहे आप ऑनलाइन इलेक्ट्रिक ऑटो बुक करना पसंद करें या टर्नो शोरूम में जाएं, हम आपको एक सुविधाजनक और परेशानी-मुक्त अनुभव प्रदान करते है। हमारी EV विशेषज्ञों की टीम हमेशा आपके सवालों के जवाब देने के लिए मौजूद रहती है जो आपको आपके व्यापार के अनुसार सही गाड़ी चुनने में मदद करती है।",
  },
    {
      id: 2,
      icon: <GroupIcon />,
      question: "फाइनेंसिंग में मदद",
      answer:
        "टर्नो आपकी EV खरीदारी को आसान बनाने के लिए गारंटीड लोन प्रदान करता है। टर्नो पर आपको कम ब्याज दर और सरल दस्तावेज़ीकरण के साथ सबसे बढ़िया EV लोन  मिलेगा। तत्काल लोन योग्यता जाँच और 48 घंटे के लोन प्राप्ति के साथ Turno आपको सबसे तेज EV लोन प्रोसेसिंग का आनंद ले।  ",
    },
    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "रखरखाव और मरम्मत सेवा",
      answer:
        "हम अपनी सेवाओं को केवल इलेक्ट्रिक ट्रक बेचने तक सीमित नहीं करते, हम बिक्री के बाद की सेवाओं को भी प्रदान करते हैं जिसमें रखरखाव और मरम्मत सेवाएं शामिल हैं। हम आपको अपनी रूटीन मेन्टेन्स की बुकिंग करने में मदद करते हैं और आपके वाहन के लिए आवश्यक पड़ने पर तत्काल समाधान प्रदान करते हैं। यह हमारा आश्वासन है कि आपका व्यापार कभी भी कोई डाउनटाइम नहीं देखेगा।",
    },
    {
      id: 4,
      icon: <PaymentIcon />,
      question: "सबसे कम डाउन पेमेंट",
      answer:
        "हम आपकी इलेक्ट्रिक टेम्पो खरीदने को पहले से भी आसान बनाते हैं जिसमें सबसे कम डाउन पेमेंट सुविधा शामिल है। अपनी इलेक्ट्रिक लोड वाहन को घर ले जाएं सिर्फ ₹49,999 की डाउन पेमेंट के साथ।",
    },
    {
      id: 5,
      icon: <PublishedWithChangesIcon />,
      question: "गाड़ी एक्सचेंज",
      answer:
        "EV ऑटो खरीदने के लिए टर्नो के आपको पुरानी गाड़ी एक्सचेंज की सुविधा भी प्रदान करता है। हम किसी भी पुरानी डीजल या सीएनजी वाहन को बदलने के लिए सर्वोत्तम दरें प्रदान करते हैं। केवल 48 घंटे में किसी भी पुराने गाड़ी को नयी इलेक्ट्रिक गाड़ी से बदले।",
    },
    {
      id: 6,
      icon: <LoopIcon />,
      question: "गारंटीड रीसेल",
      answer:
        "Turno आपको आश्वस्त EV रीसेल  की अनूठी सुविधा प्रदान करता है। आप अपनी इलेक्ट्रिक लोडर को 3 साल बाद टर्नो को बेच सकते हैं और सभी गुड्स इलेक्ट्रिक वाहनों के लिए 40% या ₹1,50,000 की आश्वस्त  मूल्य प्राप्त कर सकते हैं।",
    },

]

export const promiseDataPassengerVehicleHindi = [
  {
    id: 1,
    icon: <ElectricRickshawIcon />,
    question: "सभी टॉप EV ब्रांड एक ही जगह में",
    answer:
      "Turno एक ऐसी प्लेटफ़ॉर्म है जहां आप एक ही जगह से सभी प्रमुख ब्रांड के इलेक्ट्रिक गाड़िया खरीद सकते हैं। चाहे आप ऑनलाइन इलेक्ट्रिक ऑटो बुक करना पसंद करें या टर्नो शोरूम में जाएं, हम आपको एक सुविधाजनक और आसान EV खरीदारी का अनुभव  प्रदान करते है। हमारी EV एक्सपर्ट्स  की टीम हमेशा आपके सवालों के जवाब देने के लिए मौजूद रहती है जो आपको आपके जरुरत के अनुसार सही गाड़ी चुनने में मदद करती है।",
  },
  {
    id: 2,
    icon: <GroupIcon />,
    question: "फाइनेंसिंग में मदद",
    answer:
      "टर्नो आपकी EV खरीदारी को आसान बनाने के लिए गारंटीड लोन प्रदान करता है। टर्नो पर आपको कम ब्याज दर और सरल डॉक्यूमेंटेशन के साथ सबसे बढ़िया EV लोन  मिलेगा। तत्काल लोन योग्यता जाँच और 48 घंटे के लोन प्राप्ति के साथ Turno आपको सबसे तेज EV लोन प्रोसेसिंग",
  },
  {
    id: 3,
    icon: <WorkspacePremiumRoundedIcon />,
    question: "रखरखाव और मरम्मत सेवा",
    answer:
      "हम अपनी सेवाओं को केवल इलेक्ट्रिक ऑटो बेचने तक सीमित नहीं करते, हम बिक्री के बाद की सेवाओं को भी प्रदान करते हैं जिसमें रखरखाव और मरम्मत सेवाएं शामिल हैं। हम आपको अपनी रूटीन मेन्टेन्स की बुकिंग करने में मदद करते हैं और आपके वाहन के लिए आवश्यक पड़ने पर तत्काल समाधान प्रदान करते हैं। यह हमारा आश्वासन है कि आपका व्यापार कभी भी कोई डाउनटाइम से नहीं गुजरेगा।",
  },
  {
    id: 4,
    icon: <PaymentIcon />,
    question: "सबसे कम डाउन पेमेंट",
    answer:
      "हम आपकी इलेक्ट्रिक ई रिक्शा खरीदने को पहले से भी आसान बनाते हैं जिसमें सबसे कम डाउन पेमेंट सुविधा शामिल है। अपनी ऑटो इलेक्ट्रिक को घर ले जाएं सिर्फ ₹49,999 की डाउन पेमेंट के साथ।",
  },
  {
    id: 5,
    icon: <PublishedWithChangesIcon />,
    question: "गाड़ी एक्सचेंज",
    answer:
      "EV ऑटो खरीदने के लिए टर्नो के आपको पुरानी गाड़ी एक्सचेंज की सुविधा भी प्रदान करता है। हम किसी भी पुरानी डीजल या सीएनजी वाहन को बदलने के लिए सर्वोत्तम दरें प्रदान करते हैं। केवल 48 घंटे में किसी भी पुराने गाड़ी को नयी इलेक्ट्रिक गाड़ी से बदले।",
  },
  {
    id: 6,
    icon: <LoopIcon />,
    question: "गारंटीड रीसेल",
    answer:
      "टर्नो आपको आश्वस्त EV रीसेल  की अनूठी सुविधा प्रदान करता है। आप अपनी इलेक्ट्रिक ई रिक्शा 3 साल बाद टर्नो को बेच सकते हैं और सभी इलेक्ट्रिक ई रिक्शा के लिए 40% या ₹1,50,000 की आश्वस्त पुनर्विक्रय मूल्य प्राप्त कर सकते हैं।",
  },
];